import type { Hive } from '../../src/modules/hive'
import { setLastSyncTime } from '../../src/redux/actions/common'
import { DS_getData } from '../DS/DS.Data'
import { Sync_syncMaster } from './Sync.master'
import { User_isLoggedIn } from '../User/User.get'
import type { Base_Bus } from '../Base/Base.Bus'
import { Logg_createLogger } from '../Logg/Logg.Logger'
import { isOnline } from '../Serv/Serv.socketClient'

export function Sync_initialise(hive: Hive, bus: Base_Bus) {
    const lastSync = hive.getlastDBupdate('sync').value
    if (lastSync !== 0) {
        hive.dispatch(setLastSyncTime(lastSync))
    }

    // Register bus handler for sync requests
    bus.registerHandler('sync', async () => {
        const logger = Logg_createLogger('sync')

        const userNotLoggedIn = !User_isLoggedIn()
        if (userNotLoggedIn) {
            logger.log(`user not logged in`)
            return
        }

        const notOnline = !(await isOnline())
        if (notOnline) {
            logger.log(`not online`)
            return
        }

        await Sync_syncMaster(logger, hive, bus)
    })

    // Start regular syncs now
    Sync_reset(bus)
}

/**
 * Add sync to bus queue
 */
export function Sync_sync(label: string, bus: Base_Bus) {
    return bus.addTask('sync', label)
}

let syncInterval: number = null

/**
 * Stop regular syncs for debugging
 */
export function Sync_stop() {
    window.clearInterval(syncInterval)
}

/**
 * Sync reset starts regular sync back up again
 */
export function Sync_reset(bus: Base_Bus) {
    const tick = () => Sync_sync('Regular sync', bus)
    const timeout = DS_getData().syncInterval

    Sync_stop()
    syncInterval = window.setInterval(tick, timeout)
}
